import React, { useState } from "react";
import { FileUploader } from "react-drag-drop-files";

const fileTypes = ["JPG", "PNG", "GIF"];

function DragDrop({ file, setFile }) {
  const [previewImage, setPreviewImage] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const handleChange = (selectedFile) => {
    console.log(selectedFile);
    setFile(selectedFile);
    setPreviewImage(URL.createObjectURL(selectedFile)); // Create a preview URL for the selected file
    setErrorMessage(""); // Reset any error messages
  };

  return (
    <>
      {errorMessage && (
        <div className="text-red-500">{errorMessage}</div> // Show error message if exists
      )}
      <FileUploader
        handleChange={handleChange}
        name="file"
        types={fileTypes}
        label="Seleziona un file o trascinalo qui"
        hoverTitle="Rilascia il file qui"
        maxSize={2}
        onSizeError={() => setErrorMessage("File troppo grande")}
        onTypeError={() => setErrorMessage("Tipo di file non supportato")}
        children={
          <div
            className="flex items-center justify-center w-full h-auto bg-gray-300 mx-auto max-w-full relative rounded"
            style={{
              maxWidth: "400px",
              maxHeight: "500px",
              minHeight: "90px",
              minWidth: "90px",
              aspectRatio: "3/4",
            }}
          >
            {/* <div className="mr-20 justify-self-end">
          <img
            src={product.copertina.url}
            alt={product.copertina.fileName}
            className="w-full h-auto mx-auto max-w-full sm:max-w-sm md:max-w-md lg:max-w-lg"
            style={{
              maxWidth: "400px",
              maxHeight: "500px",
              minHeight: "90px",
              minWidth: "90px",
            }}
          />
        </div>*/}
            {previewImage ? (
              <img
                src={previewImage}
                alt="Preview"
                className="w-full h-full object-cover rounded"
              />
            ) : (
              <span className="text-gray-500">
                <span className="underline">Seleziona</span> o trascina qui{" "}
              </span>
            )}
          </div>
        }
      />
      {file ? (
        <div className="mt-4">
          <p>Nome del file: {file.name}</p>
          <p>Dimensione: {file.size * 0.000001} MB</p>
          <p>Tipo di file: {file.type}</p>
        </div>
      ) : (
        <p>Nessun file selezionato</p>
      )}
    </>
  );
}

export default DragDrop;
